import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M6.75 8.25H5C4.30964 8.25 3.75 8.80964 3.75 9.5V17C3.75 17.6904 4.30964 18.25 5 18.25H19C19.6904 18.25 20.25 17.6904 20.25 17V9.5C20.25 8.80964 19.6904 8.25 19 8.25H17.25M6.75 8.25V6.25C6.75 5.97386 6.97386 5.75 7.25 5.75H9.75C10.0261 5.75 10.25 5.97386 10.25 6.25V8.25M6.75 8.25H10.25M10.25 8.25H13.75M13.75 8.25V6.25C13.75 5.97386 13.9739 5.75 14.25 5.75H16.75C17.0261 5.75 17.25 5.97386 17.25 6.25V8.25M13.75 8.25H17.25" />
	</SVG>
);
